import { DisputedTranService } from "@/services/disputed";
import { Button, notification } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const AddNote = (props: any) => {
    const [api, contextHolder] = notification.useNotification();
    const [note, setAddNote] = useState('');

    const openNotification = (type: NotificationType, message: string) => {
        api[type]({
            message: String(type).toUpperCase(),
            description: message,
            placement: "top",
        });
    };

    const handleNoteValidation = (e: any) => {
        let val = e.target.value.trimStart();
        if (val.length <= 100) setAddNote(val);
    };

    const addNotes = async () => {
        try {
            let complaintId = props?.complaintID ?? "";
            let notes = { note: note };

            await DisputedTranService.addNotes(complaintId, notes);

            setAddNote('');
            openNotification("success", "Note added successfully");

            props.onNoteAdded && props.onNoteAdded();

        } catch (error) {
            console.log(error)
        }
    };

    return (
        <div style={{ paddingTop: "20px" }}>
            {contextHolder}

            <div style={{ padding: "20px 0px 0px 0px", borderTop: "1px solid #D7D7D7" }}>
                <div style={{ paddingBottom: "10px" }}>Add Note</div>

                <TextArea
                    style={{ color: "#33333399", border: "1px solid #D9D9D9" }}
                    onChange={handleNoteValidation}
                    value={note}
                    rows={4}
                    placeholder='Write a note..'
                />

                <div style={{ textAlign: "right" }}>
                    {note.length}/100
                </div>

                <div style={{ paddingTop: "10px" }}>
                    <Button
                        onClick={addNotes}
                        disabled={!note}
                        style={{ background: "#1890FF", color: "#fff" }}
                    >
                        Add
                    </Button>
                </div>
            </div>
        </div>
    );
};
